import { Injectable } from '@angular/core';
import { PanAppState } from '@panamax/app-state';
import { Observable } from 'rxjs';
import { FEATURES } from '@shared/constants/splitio-features';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GuestPageService {
  becomeACustomerUrl: string = environment.becomeACustomer;
  private _variant: string;
  private _splitDynamicGuestAbTestEnabled: Observable<boolean>;
  private FEATURE_FLAG_CHECK_TIMEOUT = 3000;

  constructor(
    private panAppState: PanAppState,
    private analyticsService: ProductAnalyticsService,
  ) {
    this._splitDynamicGuestAbTestEnabled = this.panAppState.featureWithTimeout$(
      [FEATURES.split_dynamic_guest_ab_test.name],
      this.FEATURE_FLAG_CHECK_TIMEOUT,
    );
  }

  public get splitDynamicGuestAbTestEnabled(): Observable<boolean> {
    return this._splitDynamicGuestAbTestEnabled;
  }

  public updateVariantValueForTracking(variant: string): void {
    this._variant = variant;
  }

  public trackBecomeACustomerButtonClickAndRedirect(): void {
    this.analyticsService.trackBecomeACustomerButtonClick(this._variant);

    const separator = this.becomeACustomerUrl.includes('?') ? '&' : '?';
    const urlWithVariant = this._variant
      ? `${this.becomeACustomerUrl}${separator}variant=guest_${this._variant?.toLowerCase()}`
      : this.becomeACustomerUrl;

    window.open(urlWithVariant, '_self');
  }
}
